import { SystemState } from "@/vuex/modules/system/system.types";

export const state: SystemState = {
  productTypes: [],
  terminals: [],
  loading: false,
  currentTerminal: null,
  pagination: null
};
